"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _array = require("../../utils/type-checks/array");
var _object = require("../../utils/type-checks/object");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge");

/**
 * Container to enforce theme width and responsive padding rules, use as a child of the main content container
 *
 * @visibleName Content Container
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const ContentContainer = props => {
  let bannerBoxComponentStyles = {},
    bannerComponentStyles = {},
    boxComponentStyles,
    componentStyles,
    backgroundStyles = {};
  const {
      background = {},
      boxClassName,
      boxStyles = {},
      children,
      className,
      customTheme = {},
      styles = {},
      testId,
      variant
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    boxClasses = (0, _classnames.default)({
      "ContentContainer__box": true,
      "bannerHeader": variant === "BannerLanding" || variant === "BannerSubLanding",
      "bannerHeaderCentered": variant === "BannerLandingCentered" || variant === "BannerSubLandingCentered",
      [`${boxClassName}`]: boxClassName
    }),
    componentClasses = (0, _classnames.default)({
      "ContentContainer": true,
      [`${className}`]: className
    }),
    {
      color = "#333333",
      image = "none",
      position = "center center",
      repeat = "no-repeat",
      size = "cover"
    } = background;
  if (background && !(0, _array.isArray)(background) && (0, _object.isObject)(background) && Object.keys(background).length > 0) {
    backgroundStyles = {
      backgroundColor: color,
      backgroundImage: image,
      backgroundPosition: position,
      backgroundRepeat: repeat,
      backgroundSize: size
    };
  }
  if (variant === "BannerLanding" || variant === "BannerLandingCentered" || variant === "BannerSubLanding" || variant === "BannerSubLandingCentered") {
    bannerComponentStyles = {
      marginTop: "0 !important",
      marginBottom: {
        xs: `${theme.contentSpacing.mobileHeader} !important`,
        md: `${theme.contentSpacing.desktopHeader} !important`
      }
    };
    bannerBoxComponentStyles = {
      alignItems: variant === "BannerLandingCentered" || variant === "BannerSubLandingCentered" ? "center" : "flex-start",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: variant === "BannerLanding" || variant === "BannerLandingCentered" ? theme.bannerHeaderHeights.landing : theme.bannerHeaderHeights.subLanding,
      paddingTop: "5.7rem",
      color: "#FFFFFF",
      " p": {
        fontSize: {
          xs: "3.2rem",
          sm: "3.6rem"
        },
        fontWeight: "600"
      },
      " h1,h2": {
        fontSize: {
          xs: "2rem !important",
          sm: "2.4rem !important"
        },
        marginBottom: "1rem !important"
      }
    };
  } else {
    bannerBoxComponentStyles = {
      display: "block"
    };
  }
  boxComponentStyles = merge.all([theme.mixins.container.inner, bannerBoxComponentStyles, boxStyles]);
  componentStyles = merge.all([theme.mixins.container.outer, backgroundStyles, bannerComponentStyles, styles]);
  return /*#__PURE__*/_react.default.createElement(_material.Container, {
    className: componentClasses,
    "data-testid": testId,
    sx: componentStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: boxClasses,
    sx: boxComponentStyles
  }, children));
};

// Define propTypes;
ContentContainer.propTypes = {
  /** Object containing background style properties (Default Value: {}) */
  background: _propTypes.default.shape({
    color: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    image: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    position: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    repeat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
    size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
  }),
  /** Custom classname(s) for interior box component */
  boxClassName: _propTypes.default.string,
  /** Custom styles for interior box component (Default Value: {}) */
  boxStyles: _propTypes.default.object,
  /** Child content */
  children: _propTypes.default.any.isRequired,
  /** Custom classname(s) for the component */
  className: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Custom style object for the component (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Optional variant indicator if the banner is a header or a centered header */
  variant: _propTypes.default.oneOf(["BannerLanding", "BannerLandingCentered", "BannerSubLanding", "BannerSubLandingCentered"])
};

// Export component as default;
var _default = exports.default = ContentContainer;